import React from 'react';
import {ScrollView} from 'react-native';

import OpenURLButton from '../../components/OpenURLButton';
import ContentView from '../../components/ui-controls/layout/ContentView';
import {FlatListMenuItem} from '../../components/ui-controls/MenuFlatList';
import Text from '../../components/ui-controls/Text';
import config from '../../config';
import {AppRoute} from '../../models/AppRoute';
import {RouteNavigatorScreenProps} from '../../models/navigationTypes';

const ResponsibleServiceScreen = ({
  navigation,
}: RouteNavigatorScreenProps<AppRoute.RESPONSIBLE_SERVICE>) => {
  const handleMenuItemPress = (item: any) => navigation.navigate(item.target);

  const items = [
    {
      target: AppRoute.RESPONSIBLE_SERVICE_LIQUOR_LICENSING_LAWS,
      name: 'Liquor Licensing Laws',
    },
    {
      target: AppRoute.RESPONSIBLE_SERVICE_THIRD_PARTY_REQUEST,
      name: '3rd Party Request',
    },
    {target: AppRoute.SELF_EXCLUSION, name: 'Self Exclusion'},
  ];

  return (
    <ScrollView testID="help-contact-screen">
      <ContentView>
        <Text>
          {config.APP_NAME} takes the responsible service of alcohol seriously,
          which is why we are a member of the Retail Drinks Online Code of
          Conduct. Complying with the Retail Drinks Code is one of the ways we
          make sure we are meeting community expectations in relation to the
          responsible sale and service of alcohol.
          {'\n'}
          {'\n'}
          If you would like any further information about responsible
          consumption, you can head to{' '}
          <OpenURLButton url="https://drinkwise.org.au/">
            Drinkwise
          </OpenURLButton>
          , or the{' '}
          <OpenURLButton url="https://code.retaildrinks.org.au/">
            Retail Drinks Code
          </OpenURLButton>
          , and if you would like to exclude from our online alcohol purchasing
          services, or a take a break for a while, please use the Self Exclusion
          option below.
        </Text>
        {/* TODO: This previously used FlatListMenu but the FlatList was not visible
        on small iOS screens and it was not possible to scroll to see it. Also,
        using ContentView and FlatList at the same time has issues.*/}
        <FlatListMenuItem item={items[0]} onPressItem={handleMenuItemPress} />
        <FlatListMenuItem item={items[1]} onPressItem={handleMenuItemPress} />
        <FlatListMenuItem item={items[2]} onPressItem={handleMenuItemPress} />
      </ContentView>
    </ScrollView>
  );
};

export default ResponsibleServiceScreen;
